import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NotificationInboxPage } from '@core/models/notification-inbox';

@Injectable({ providedIn: 'root' })
export class NotificationInboxService {
  private unreadCountSubject = new BehaviorSubject<number>(0);
  readonly unreadCount$ = this.unreadCountSubject.asObservable();

  constructor(private _http: HttpClient) { }

  getNotifications(page = 0, size = 20): Observable<NotificationInboxPage> {
    return this._http.get<NotificationInboxPage>(`${environment.apiUrl}/notification-inbox`, {
      params: { page, size }
    });
  }

  markAllAsRead(): Observable<void> {
    return this._http.patch<void>(`${environment.apiUrl}/notification-inbox/read-all`, {}).pipe(
      tap(() => this.unreadCountSubject.next(0))
    );
  }

  markAsRead(id: number): Observable<void> {
    return this._http.patch<void>(`${environment.apiUrl}/notification-inbox/${id}/read`, {}).pipe(
      tap(() => this.unreadCountSubject.next(Math.max(0, this.unreadCountSubject.value - 1)))
    );
  }
}
